"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GroupItem = require("./GroupItem");

var _GroupItem2 = _interopRequireDefault(_GroupItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _GroupItem2.default;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wel-ui/component-group/lib/GroupItem/index.js
// module id = 327
// module chunks = 0